var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "vkkva",
    d: "M1287.031 7982.612c.324-.308.485-.697.479-1.158-.006-.466-.17-.856-.484-1.162-.314-.305-.739-.46-1.261-.46-.523 0-.952.155-1.276.46a1.534 1.534 0 0 0-.489 1.162c0 .46.16.85.474 1.158.314.309.736.465 1.252.465h.02c.528 0 .961-.156 1.285-.465zm.28 1.746h-3.131v9.401h3.131zm4.848 4.155c0-.32.035-.579.104-.769.131-.32.334-.593.602-.81.267-.218.604-.328 1-.328.542 0 .946.19 1.201.564.255.376.385.9.385 1.56v5.03l3.12-.002v-5.387c0-1.38-.332-2.441-.986-3.155-.655-.714-1.533-1.077-2.609-1.077-.395 0-.76.05-1.086.148a2.483 2.483 0 0 0-.825.412c-.221.174-.402.34-.537.493a4.197 4.197 0 0 0-.37.501v-1.335h-3.12l.01.455c.005.296.008 1.188.008 2.808 0 1.624-.006 3.689-.019 6.138l3.12.001h.002z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1284 -7979)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    xlinkHref: "#vkkva"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinked);
export default __webpack_public_path__ + "static/media/linked.feab379da6d6c1b2892390fafc200d7b.svg";
export { ForwardRef as ReactComponent };